import React, { ReactElement, useContext } from 'react';
import { CommunityContext } from '../../common_lib_front/communityConfigs/communityContextProvider';
import style from './vehicleTypeSelect.module.css';

interface VehicleTypeSelectProps {
  htmlFor: string;
  labelTitle?: string;
  inputValue?: string | undefined;
  changeHandler?: ((e: React.ChangeEvent<HTMLSelectElement>) => void) | undefined;
  labelStyle?: string;
  inputStyle?: string;
  smallSize?: boolean;
  largeSize?: boolean;
  lightText?: boolean;
  // enables or disables style changing on focus and blur
  highlightOnFocus?: boolean;
  required?: boolean;
}

export const VehicleTypeSelect = (props: VehicleTypeSelectProps): ReactElement => {
  const { communityId } = useContext(CommunityContext);

  const { labelTitle, htmlFor, changeHandler, inputValue, required } = props;

  return (
    <div className={style.container}>
      <label className={style.labelBox} htmlFor={htmlFor}>
        <div className={`${style.text} textColorSuperDark `}>{labelTitle}</div>
        <div className={style.selectBox}>
          <select
            className={style.select}
            value={inputValue}
            id={htmlFor}
            onChange={changeHandler}
            required={required}
          >
            <option selected disabled hidden>
              {' '}
            </option>
            <option>Coupe (2 Door Car)</option>
            <option>Sedan (4 Door Car)</option>
            <option>Sports Car</option>
            <option>Wagon/Station Wagon</option>
            <option>Sports Utility Vehicle (SUV)</option>
            <option>Minivan</option>
            <option>High Capacity Passenger Van</option>
            <option>Pickup Truck</option>
            {communityId === 'sipoa' && <option>LSV</option>}
            <option>Motorcycle</option>
            <option>OHV (Off Highway Vehicle)</option>
            <option>Golf Cart</option>
            <option>Bus</option>
            <option>Utility Truck</option>
            <option>Other Commercial Vehicle (Box Truck/Semi)</option>
          </select>
        </div>
      </label>
    </div>
  );
};
VehicleTypeSelect.defaultProps = {
  labelTitle: '',
  inputValue: undefined,
  changeHandler: undefined,
  labelStyle: ' default_style',
  inputStyle: ' default_style',
  smallSize: false,
  largeSize: false,
  lightText: false,
  highlightOnFocus: false,
  required: false,
};

export default VehicleTypeSelect;
